import React, { Component } from "react";
import Joi from "joi-browser";
import Input from "./input";
import Textarea from "./textarea";
import Password from "./password";
import DateInput from "./dateInput";
import SearchInput from "./searchInput";
import PublishDate from "./publishDate";
import Select from "./select";
import SelectUpdate from "./selectUpdate";

class Form extends Component {
  state = {
    data: {},
    errors: {},
  };

  getMaxDob = () => {
    const type = this.props.data?.type;
    return type === 2
      ? new Date()
      : new Date(new Date().setFullYear(new Date().getFullYear() - 18));
  };

  validate = () => {
    const context = { maxDob: this.getMaxDob() };
    const { error } = Joi.validate(this.state.data, this.schema, { abortEarly: false, context });
    if (!error) return null;

    const errors = {};
    for (let item of error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const context = name === "date_of_birth" ? { maxDob: this.getMaxDob() } : {};
    const { error } = Joi.validate(obj, schema, { abortEarly: false, context });
    return error ? error.details[0].message : null;
  };

  setErrors = (input) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);

    if (errorMessage) {
      errors[input.name] = errorMessage;
    } else {
      delete errors[input.name];
    }

    if (input.name === "confirmPassword") {
      if (this.state.data.password === input.value) {
        delete errors[input.name];
      }
    }

    this.setState({ errors });
  };

  setData = (input) => {
    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({ data });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const maxDob = this.props.data?.type === 2
      ? new Date()
      : new Date(new Date().setFullYear(new Date().getFullYear() - 18));
    const errors = this.validate({ maxDob });
    this.setState({ errors: errors || {} });
    if (errors) return;

    this.doSubmit();
  };

  handleChangeSelect = ({ currentTarget: input }) => {
    this.setErrors(input);
    this.setData(input);
  };

  handleChange = ({ currentTarget: input }) => {
    this.setData(input);
  };

  handleBlur = ({ currentTarget: input }) => {
    this.setErrors(input);
  };

  renderButton(label) {
    return (
      <button disabled={this.validate()} className="btn btn-primary">
        {label}
      </button>
    );
  }

  renderDateInput(name, label, options, defaultValue) {
    const { data, errors } = this.state;
    return (
      <DateInput
        name={name}
        showYearDropdown
        showMonthDropdown
        selected={data[name]}
        label={label}
        options={options}
        onChange={(date) =>
          this.handleChangeSelect({
            currentTarget: { value: date, name: "date_of_birth" },
          })
        }
        error={errors[name]}
        defaultValue={defaultValue}
        type="text"
      />
    );
  }

  renderDate(name, label, options, defaultValue) {
    const { data, errors } = this.state;
    return (
      <PublishDate
        name={name}
        showYearDropdown
        showMonthDropdown
        selected={data[name]}
        label={label}
        options={options}
        onChange={(date) =>
          this.handleChangeSelect({
            currentTarget: { value: date, name: "date" },
          })
        }
        error={errors[name]}
        defaultValue={defaultValue}
        type="text"
      />
    );
  }
  renderInput(name, label, type = "text") {
    const { data, errors } = this.state;

    return (
      <Input
        type={type}
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        error={errors[name]}
      />
    );
  }
  renderSelect(name, label, options, readOnly = false, defaultValue) {
    const { data, errors } = this.state;

    return data[name] ? (
      <SelectUpdate
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={this.handleChangeSelect}
        error={errors[name]}
        defaultValue={defaultValue}
        readOnly={readOnly}
      />
    ) : (
      <Select
        name={name}
        value={data[name]}
        label={label}
        options={options}
        onChange={this.handleChangeSelect}
        error={errors[name]}
        defaultValue={defaultValue}
        readOnly={readOnly}
      />
    );
  }

  renderTextarea(name, label, type = "text") {
    const { data, errors } = this.state;

    return (
      <Textarea
        type={type}
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        error={errors[name]}
      />
    );
  }
  renderSearchInput(name, label, type = "text") {
    const { data, errors } = this.state;

    return (
      <SearchInput
        type={type}
        name={name}
        value={data[name]}
        placeholder={label}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        error={errors[name]}
      />
    );
  }

  renderPasswordInput(name, label, type = "password") {
    const { data, errors } = this.state;

    return (
      <Password
        type={type}
        name={name}
        value={data[name]}
        label={label}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        error={errors[name]}
      />
    );
  }
}

export default Form;
